import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Theme, SxProps, Typography } from '@mui/material';

const FIGMA_CARD_WIDTH = 1098;

const EXPLAINER_STRINGS = appStrings.modules.lifeReadiness.explainerCard;

export const ExplainerCard = () => {
  return (
    <Box sx={containerSx}>
      <Box sx={headerContainerSx}>
        <Typography
          variant="display-md-semibold"
          color={({ backrs }) => backrs.colors['Colors/Text/text-primary-on-brand']}
        >
          {EXPLAINER_STRINGS.title}
        </Typography>
        <Typography
          variant="text-lg-medium"
          color={({ backrs }) => backrs.colors['Colors/Text/text-primary-on-brand']}
        >
          {EXPLAINER_STRINGS.description}
        </Typography>
      </Box>

      <Box sx={contentContainerSx}>
        <Box sx={descriptionContainerSx}>
          <Typography variant="text-lg-bold">
            {EXPLAINER_STRINGS.cardBodyTitle}
            <Typography variant="text-lg-regular" component="span">
              {EXPLAINER_STRINGS.cardBodyDescription}
            </Typography>
          </Typography>
        </Box>

        <Box sx={imageContainerSx}>
          <img src="/images/life-readiness-explainer-card.png" alt="Life-Readiness Assessment" />
        </Box>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-primary']}`,
  overflow: 'hidden',
  maxWidth: {
    xs: `85vw`,
    md: `${FIGMA_CARD_WIDTH}px`,
  },

  // target medium size tablets
  '@media screen and (max-width: 1205px) and (max-height: 768px)': {
    maxWidth: '85vw',
  },
});

const headerContainerSx: SxProps<Theme> = ({ backrs }) => ({
  flexDirection: 'column',
  backgroundColor: backrs.colors['Colors/Background/bg-primary-solid'],
  paddingX: backrs.spacing['spacing-3xl'],
  paddingY: backrs.spacing['spacing-2xl'],
});

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Base/White'],
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
});

const descriptionContainerSx: SxProps<Theme> = ({ backrs }) => ({
  padding: backrs.spacing['spacing-5xl'],
  width: { xs: '100%', md: '50%' },
  whiteSpace: 'pre-line',
});

const imageContainerSx: SxProps<Theme> = ({ backrs }) => ({
  borderTop: { xs: `1px solid ${backrs.colors['Colors/Base/Black']}`, md: 'none' },
  borderLeft: { xs: 'none', md: `1px solid ${backrs.colors['Colors/Base/Black']}` },
  width: { xs: '100%', md: '50%' },
  backgroundColor: backrs.colors['Colors/Background/bg-brand-secondary'],
  padding: backrs.spacing['spacing-4xl'],
  display: 'flex',
  justifyContent: 'center',

  img: {
    maxWidth: '100%',
    maxHeight: { xs: '300px', lg: '360px' },
    objectFit: 'contain',
    height: 'auto',
  },
});
